import type { FC } from 'react';
import { Box } from '@mui/material';

// Brand-consistent boot splash. Uses the Mystic monogram on the brand-black
// background (same as the nav) so a fast/hard refresh never flashes the old
// "Relight" logo before the app renders.
export const SplashScreen: FC = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: '#0a0a0b',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 1400
    }}
  >
    <Box
      component="img"
      src="/favicon-white.png"
      alt="Mystic Media Film"
      sx={{
        height: 52,
        width: 52,
        objectFit: 'contain'
      }}
    />
  </Box>
);
